<script>
export default {
    name: "WorkWithUsLineTop"
}
</script>
<template>
    <svg aria-hidden="true" viewBox="0 0 18 81" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 81L9.00001 -3.21865e-06" stroke="#6B919B"/>
        <line x1="18" y1="0.5" y2="0.5" stroke="#6B919B"/>
    </svg>
</template>
